<template>
  <v-row>
    <v-col
      v-if="isLoading"
      cols="12"
      class="text-center"
    >
      <v-progress-circular
        :size="125"
        :width="10"
        color="primary"
        indeterminate
      />
    </v-col>
    <v-col
      v-if="!isLoading"
      cols="12"
    >
      <v-row>
        <v-col cols="12" xs="12" md="6">
          <invoice-customer-card
            :init-customer="model.customer"
            class="mb-5"
          />
        </v-col>
        <v-col cols="12" xs="12" md="6">
          <invoice-billing-card
            :invoice="model"
            class="mb-5"
            @update="updateBilling"
          />
        </v-col>

      </v-row>

      <invoice-items-basket
        ref="basket"
        :init-invoice="model"
        class="mb-5"
        @update="updateBasket"
      />

      <v-row>
        <v-col
          v-if="model.status === 'draft'"
          cols="12"
        >
          <v-divider class="my-5" />

          <v-btn
            rounded
            outlined
            class="mr-3"
            @click="$router.push({ name: 'customer-detail', params: { id: model.customer.id } })"
          >
            <v-icon small left>save</v-icon>
            Save & close
          </v-btn>

          <v-btn
            v-if="isManualDraft()"
            :loading="isActionLoading || isBasketLoading()"
            :disabled="isActionLoading || isBasketLoading()"
            rounded
            outlined
            color="primary"
            @click="onPrimaryAction"
          >
            <v-icon
              left
              small
            >
              {{
              model.collection_method === 'send_invoice'
              ? 'send'
              : 'payment'
              }}
            </v-icon>
            {{
              model.collection_method === 'send_invoice'
                ? 'Send invoice'
                : 'Charge customer'
            }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions } from 'vuex'
import { get, isString } from 'lodash'
import InvoiceCustomerCard from "./InvoiceCustomerCard"
import InvoiceItemsBasket from "./InvoiceItemsBasket"
import InvoiceBillingCard from "./InvoiceBillingCard"

import invoices from "../../stores/modules/invoices"

export default {
  components: { InvoiceBillingCard, InvoiceCustomerCard, InvoiceItemsBasket },
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {

  },
  created() {
    // specifically not mounted
    this.model = { ...this.invoice }
  },
  methods: {
    ...mapActions([ 'getInvoice', 'getCustomer', 'updateInvoice', 'payInvoice', 'sendInvoice' ]),
    onPrimaryAction() {
      this.model.collection_method === 'send_invoice'
        ? this.doSendInvoice()
        : this.chargeCustomer()
    },
    isManualDraft() {
      return this.model.billing_reason === 'manual'
        && this.model.status === 'draft'
    },
    isBasketLoading() {
      const val = this.$refs.basket ? this.$refs.basket.isABasketItemLoading() : false
      return val
    },
    async doSendInvoice() {
      const payload = {
        id: this.model.id
      }
      this.isActionLoading = true
      const invoice = await this.sendInvoice(payload)
      this.isActionLoading = false

      if (invoice) {
        this.$router.push({ name: 'customer-detail', params: { id: this.model.customer.id } })
      }
    },
    async chargeCustomer() {
      const payload = {
        id: this.model.id
      }
      this.isActionLoading = true
      const invoice = await this.payInvoice(payload)
      this.isActionLoading = false

      if (invoice) {
        this.$router.push({ name: 'customer-detail', params: { id: this.model.customer.id } })
      }
    },
    async updateBilling(data) {
      const { collection_method, due_date, default_source, default_payment_method } = data

      const modelClone = { ...this.model }
      modelClone.collection_method = collection_method
      modelClone.default_source = default_source
      modelClone.default_payment_method = default_payment_method

      if (collection_method === 'send_invoice') {
        modelClone.due_date = due_date
      } else {
        modelClone.due_date = undefined
      }

      this.model = modelClone

      /**
       * Removing default_source in payload since both and default_payment_method cannot be provided
       */
      const payload = {
        id: this.model.id,
        collection_method,
        //default_source, // deprecated
        default_payment_method,
        due_date,
        //days_until_due, // not implemented properly in Stripe yet
        expand: ['total_tax_amounts.tax_rate', 'customer']
      }

      this.isActionLoading = true
      await this.updateInvoice(payload)
        .then((res) => {
          this.model = res
        })
      this.isActionLoading = false
    },
    async updateBasket(data) {
      const { coupon, default_tax_rates, lines } = data

      // coupon is mapped to discount
      const payload = {
        id: this.invoice.id,
        coupon,
        default_tax_rates,
        lines,
        expand: ['total_tax_amounts.tax_rate', 'customer']
      }

      this.model = {
        ...this.model,
        ...payload
      }

      this.isActionLoading = true
      await this.updateInvoice(payload)
        .then((res) => {
          this.model = res
        })
      this.isActionLoading = false
    }
  },
  data() {
    return {
      isLoading: false,
      isActionLoading: false,
      model: {
        coupon: undefined,
        collection_method: undefined,
        days_until_due: undefined,
        due_date: undefined,
        default_source: undefined, // deprecated
        default_payment_method: undefined,
        custom_fields: undefined,
        default_tax_rates: undefined,
        lines: []
      }
    }
  },

}
</script>
